import { modifier } from 'ember-modifier';

export interface AutoFocusModifierSignature {
  Element: HTMLFormElement | HTMLInputElement;
}
export default modifier<AutoFocusModifierSignature>((element) => {
  element.focus();
});
